<template>
    <div class="card-container">
        <div class="screen-card" @click="openEditDialog(screenInfo, 2)">
            <a-popconfirm overlayClassName="del-confirm-box" ok-text="确定" cancel-text="取消" @confirm="confirmDel(screenInfo.id)">
                <template slot="title">
                  <p class="confirm-tip">确认要删除本页大屏吗？</p>
                  <p class="del-tip">删除后，本页大屏将不再展示；如需展示，请在此添加<br>自定义大屏</p>
                </template>
                <a-icon
                  v-if="screenInfo.pageType === 2"
                  type="close-circle"
                  theme="filled"
                  class="del-btn"
                  :style="{ fontSize: '20px', color: '#A6A9B1'}"
                  @click.stop
                />
            </a-popconfirm>
            <div class="screen-type" :class="screenInfo.pageType === 1 ? 'gray-bg' : 'purple-bg'">{{ screenInfo.pageType === 1 ? '系统' : '自定义' }}</div>
            <div class="screen-title text-overflow-one" v-if="screenInfo.activated">{{ `第${screenInfo.sort}页-${screenInfo.pageName}` }}</div>
            <div class="screen-title text-overflow-one" v-else>{{ screenInfo.pageName }}</div>
            <div class="screen-info">
                {{ screenInfo.pageDescribe || '' }}
            </div>    
        </div>
        <AddDialog
          :showAddDialog.sync="showAddDialog"
          :currentScreenInfo="screenInfo"
          :showType="showType"
          @editScreenlist="editScreenlist"
        />
    </div>
</template>

<script>
import AddDialog from './addOrEditDialog.vue'

export default {
    name: 'DataScreen',
    components: {
        AddDialog
    },
    props: {
        screenInfo: {
            type: Object,
            default: null
        },
    },
    data() {
        return {
            showAddDialog: false,
            currentScreenItem: null,
            reselectList: [],
            showType: 0
        }
    },
    methods: {
        openEditDialog(item, type) {
            this.currentScreenItem = item
            this.showType = type
            this.showAddDialog = true
        },
        editScreenlist() {
            this.$emit('updateScreenPageList')
        },
        async confirmDel(id) {
            const delRes = await this.$http.delScreenPage({
                id: id
            })
            if (delRes.code == 200) {
                this.$message.success('删除成功');
                this.$emit('updateScreenPageList')
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.card-container {
    margin-bottom: 16px;
    &:last-child {
        margin-bottom: 0;
    }
}
.screen-card {
    width: 100%;
    height: 116px;
    padding: 13px 56px 13px 16px;
    font-size: 14px;
    border-radius: 4px;
    text-align: left;
    background: #fff;
    position: relative;
    box-shadow: 0px 2px 6px 0px rgba(31, 40, 100, 0.1);
    cursor: pointer;
    .del-btn {
        position: absolute;
        top: 0;
        left: -10px;
        z-index: 9;
    }
    .screen-type {
        position: absolute;
        top: 0;
        right: 0;
        width: 60px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        font-size: 12px;
        border-radius: 0 4px 0 4px;
        color: #fff;
    }
    .gray-bg {
        background: #9CA5B1;
    }
    .purple-bg {
        background: #5F60D3;
    }
    .screen-title {
        height: 16px;
        line-height: 16px;
        color: #1E2228;
    }
    .screen-info {
        margin-top: 10px;
        height: 60px;
        line-height: 20px;
        color: #9CA5B1;
        display: -webkit-box;
        text-overflow: ellipsis;
        overflow: hidden;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
    }
}
.confirm-tip {
    font-size: 16px;
    color: #000;
}
.del-tip {
    margin-top: 12px;
}
</style>